import { createRouter, createWebHistory } from 'vue-router'
import MableScreener from '../views/MableScreener.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/demo/:code(\\d{4})?',
      name: 'demo',
      component: MableScreener,
      meta: { wasReloaded: false },
      props: (route) => ({ demo: true, code: route.params.code || null }),
      beforeEnter: (to, from, next) => {
        const hadCodeEntered = window.location.pathname !== '/'
        if (hadCodeEntered) {
          to.meta.wasReloaded = true
        }
        next()
      }
    },
    {
      path: '/status',
      name: 'status',
      component: MableScreener
    },
    {
      path: '/:code(\\d{4})?',
      name: 'home',
      component: MableScreener,
      meta: { wasReloaded: false },
      props: (route) => ({ emailScreenerId: route.query.screenerId || null }),
      beforeEnter: (to, from, next) => {
        const hadCodeEntered = window.location.pathname !== '/' // if there is anything after the slash, a code was entered
        if (hadCodeEntered) {
          to.meta.wasReloaded = true
        }

        next()
      }
    },
    {
      // Catch-all route: redirect to home for any other paths
      path: '/:pathMatch(.*)*',
      redirect: { name: 'home' }
    }
  ]
})

export default router
